import { merge } from '../../helper';

import removeClass from '../../general/class/removeClass';

// ----------------------------------------------------------------------------

export type TypeInputElements = HTMLInputElement | HTMLInputElement[];

export type TypeGeneralConfig = {
    validation?: Record<string, any>;
};

// ----------------------------------------------------------------------------

function general(elements: TypeInputElements, config?: TypeGeneralConfig): void {
    text(elements);
    validation(elements, config?.validation);
}

// ----------------------------------------------------------------------------

function text(elements: TypeInputElements): void {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        // If there is type button or submit
        if (['button', 'submit'].includes(element.type)) {
            continue;
        }

        // Clear value
        element.value = '';
    }
}

function validation(elements: TypeInputElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        className: 'is-valid is-invalid',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        removeClass(element, defConfig.className);
    }
}

// ----------------------------------------------------------------------------

export { general, text, validation };
